import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    switchLabel: {
      paddingLeft: 5,
      marginBottom: 10,
      "& .MuiTypography-body1": {
        fontSize: "0.9rem"
      }
    },
    segmentDialogContent: {
      paddingTop: 0
    },
    toolTip: {
      backgroundColor: "rgb(212, 235, 252)",
      color: "rgb(13, 60, 97)",
      fontSize: "0.7rem"
    },
    arrow: {
      color: "rgb(212, 235, 252)"
    },
    popper: {
      zIndex: 100
    }
  })
);
